module.exports = __webpack_public_path__ + "static/img/honour4.21f2e2a3.png";